/**
 * Catálogo de ítems. Datos, no código, igual que las salas y los juegos.
 *
 * El ORDEN de `ITEM_SLOTS` es el orden de dibujo, de abajo hacia arriba. Cambiarlo
 * cambia qué tapa a qué, así que no es una lista cualquiera.
 *
 * Una ranura admite un solo ítem a la vez: equipar un sombrero reemplaza el que
 * hubiera. Eso es lo que evita dos gorras apiladas.
 */
export const ITEM_SLOTS = ["accessory", "hat"];
export const ITEM_IDS = ["lentes", "gorra-espol", "gorro-lana", "cafe", "dona", "gorra-club"];
export const ITEMS = {
    lentes: { id: "lentes", name: "Lentes de estudio", slot: "accessory", price: 20 },
    "gorra-espol": { id: "gorra-espol", name: "Gorra ESPOL", slot: "hat", price: 35 },
    "gorro-lana": { id: "gorro-lana", name: "Gorro de lana", slot: "hat", price: 50 },
    /*
     * Lo del Sweet & Coffee. Ocupan la ranura de accesorio porque es lo que se lleva en
     * la mano: comprarse un café y pasearlo por el campus es media gracia del local.
     */
    cafe: { id: "cafe", name: "Café del Sweet", slot: "accessory", price: 15 },
    dona: { id: "dona", name: "Dona glaseada", slot: "accessory", price: 12 },
    /*
     * La gorra del club: la lleva quien es de un club, con el color de su club.
     *
     * Es un ítem normal en todo salvo dónde se compra, y por eso vive acá y no en un
     * catálogo paralelo: se equipa, se dibuja y se guarda igual que una gorra cualquiera.
     * Lo único propio es la puerta por la que se entra a comprarla.
     */
    "gorra-club": {
        id: "gorra-club",
        name: "Gorra del club",
        slot: "hat",
        price: 60,
        club: true,
    },
};
/** Lo que vende el mostrador del campus: todo menos lo que es de un club. */
export const SHOP_ITEMS = ITEM_IDS.map((id) => ITEMS[id]).filter((item) => item.club !== true);
export const ITEM_LIST = ITEM_IDS.map((id) => ITEMS[id]);
export function isItemId(value) {
    return typeof value === "string" && ITEM_IDS.includes(value);
}
export function getItem(id) {
    return isItemId(id) ? ITEMS[id] : undefined;
}
export function isItemSlot(value) {
    return typeof value === "string" && ITEM_SLOTS.includes(value);
}
/** Ordena ids de ítem por orden de dibujo, descartando los desconocidos. */
export function inDrawOrder(itemIds) {
    return itemIds
        .map((id) => getItem(id))
        .filter((item) => item !== undefined)
        .sort((a, b) => ITEM_SLOTS.indexOf(a.slot) - ITEM_SLOTS.indexOf(b.slot));
}
//# sourceMappingURL=items.js.map